 
export const utc_start_datetime = `2026-01-23T05:35:00.000Z`
export const utc_end_datetime =  `2026-02-23T11:16:53.000Z`
export const timestamp_key = 'timestamp'
export const value_key = 'value'

export const  data = () => ([
        { 
            "timestamp": "2026-01-23T00:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.25,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.59,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.35,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.22,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.26,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.12,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.33,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.88,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.49,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.43,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.35,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.9,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.61,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.67,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.83,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.65,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.25,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.76,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.88,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.86,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.67,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.85,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.09,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.99,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.77,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.76,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.61,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.2,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.15,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.49,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.75,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.13,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.09,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.45,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.45,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.3,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.68,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.6,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 88.94,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T00:53:00-05:00",
            "psu_name": "BLOCKER_ORIFICE_TEST",
            "value": 100.0,
            "unit": "%",
            "target": 95,
            "color": "#0076cc",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:10:00-05:00",
            "psu_name": "BLOCKER_ORIFICE_TEST",
            "value": 100.0,
            "unit": "%",
            "target": 95,
            "color": "#0076cc",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:16:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 87.02,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:17:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 86.59,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 96.45,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.83,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.23,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.2,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.77,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.98,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.59,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.28,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.29,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.75,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.47,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.21,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.12,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.41,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.65,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.38,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.22,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.43,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.52,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.44,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.66,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.52,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.16,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 86.84,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:53:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.49,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:54:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.85,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:55:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:56:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.53,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:57:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.08,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:58:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.6,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T01:59:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.35,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.95,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.37,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.15,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.36,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.72,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.76,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.89,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.29,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.88,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.08,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.37,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.38,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.87,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.13,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.09,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.28,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.83,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.51,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.13,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.81,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.41,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.29,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.75,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.82,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.71,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.6,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.8,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.61,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.16,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.71,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.36,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.4,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.7,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.1,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.7,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 96.01,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.65,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.41,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.77,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.72,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.65,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 96.1,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.98,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.95,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:53:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.48,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:54:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:55:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.97,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:56:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:57:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:58:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.58,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T02:59:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.64,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.38,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.8,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.26,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.22,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.54,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.53,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.45,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.94,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.31,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.57,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.38,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.79,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.02,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.63,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.72,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.23,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.84,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:23:00-05:00",
            "psu_name": "BLOCKER_ORIFICE_TEST",
            "value": 100.0,
            "unit": "%",
            "target": 95,
            "color": "#0076cc",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:43:00-05:00",
            "psu_name": "BLOCKER_ORIFICE_TEST",
            "value": 100.0,
            "unit": "%",
            "target": 95,
            "color": "#0076cc",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:58:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 86.91,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T03:59:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 85.12,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:00:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 87.11,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:01:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 85.44,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:02:00-05:00",
            "psu_name": "ALL_NUGGETS",
            "value": 86.66,
            "unit": "%",
            "target": 69,
            "color": "#E66C37",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.51,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.43,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.54,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.25,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 91.89,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.94,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.91,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.44,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.96,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.27,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.31,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.35,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.75,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.75,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.23,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.77,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.68,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.28,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.51,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.18,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.68,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.33,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.96,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.46,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.33,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.31,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.16,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.74,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.53,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.41,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.09,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:53:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.95,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:54:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:55:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.52,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:56:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.12,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:57:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.62,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:58:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.79,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T04:59:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.68,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.4,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.11,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.88,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.26,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.57,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.78,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.86,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.91,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.12,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.01,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.4,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.1,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.86,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.26,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.23,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.2,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.63,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.46,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.5,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.8,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.44,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.66,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.31,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.0,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.32,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.23,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.68,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.45,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.48,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.36,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.11,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.37,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.97,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.03,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.04,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.35,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:53:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:54:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.16,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:55:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.58,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:56:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.82,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:57:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:58:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.01,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T05:59:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.14,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.73,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.67,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.24,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.31,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.2,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.1,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.69,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 91.76,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.58,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.4,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:13:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.72,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:14:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.36,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:15:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.47,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:16:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.57,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:17:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 90.99,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:18:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.56,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:19:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.98,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:20:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.3,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:21:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.61,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:22:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.8,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:23:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.89,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:24:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.76,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:25:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.37,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:26:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.01,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:27:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.82,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:28:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.48,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:29:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:30:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.27,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:31:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.0,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:32:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.05,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:33:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.59,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:34:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:35:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.64,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:36:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.28,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:37:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.3,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:38:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.64,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:39:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.46,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:40:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.78,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:41:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.39,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:42:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:43:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.36,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:44:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.06,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:45:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.38,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:46:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.27,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:47:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.74,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:48:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.49,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:49:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.7,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:50:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.34,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:51:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.25,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:52:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.54,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:53:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.85,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:54:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 90.88,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:55:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.71,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:56:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.78,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:57:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.08,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:58:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.6,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T06:59:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.07,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:00:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.55,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:01:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.84,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:02:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.95,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:03:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 88.19,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:04:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 91.51,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:05:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.16,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:06:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 92.67,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:07:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.8,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:08:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.67,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:09:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 95.04,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:10:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.17,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:11:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 93.92,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        },
        {
            "timestamp": "2026-01-23T07:12:00-05:00",
            "psu_name": "CFA_SPICY_AND_NUGGETS",
            "value": 94.33,
            "unit": "%",
            "target": 95,
            "color": "#C83D95",
            "value_red": 93,
            "value_green": 95
        }
    ])